import React, { useState } from 'react';
import ConfirmationPopup from '../ConfirmationPopup';

const CommodityUploadModal = ({ 
    isOpen, 
    onClose, 
    tradedCommodities, 
    onCommoditySelect,
    uploading 
}) => {
    const [selectedCommodity, setSelectedCommodity] = useState('');
    
    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        
        if (!selectedCommodity) {
            alert('Please select a commodity type first');
            return;
        }
        
        onCommoditySelect(selectedCommodity, file);
        onClose();
        setSelectedCommodity(''); // Reset selection for next time
    };
    
    if (!isOpen) return null;
    
    return (
        <ConfirmationPopup
            message={
                <div style={{ textAlign: 'left' }}>
                    <h3 style={{ 
                        margin: '0 0 1rem 0', 
                        color: '#374151',
                        fontSize: '1.25rem',
                        fontWeight: '600'
                    }}>
                        Upload COA Certificate
                    </h3>
                    <div style={{ marginBottom: '1.5rem' }}>
                        <label style={{ 
                            display: 'block',
                            marginBottom: '0.5rem',
                            fontWeight: '500',
                            color: '#374151'
                        }}>
                            Select Commodity Type: <span style={{ color: '#ef4444' }}>*</span>
                        </label>
                        <select 
                            value={selectedCommodity}
                            onChange={(e) => setSelectedCommodity(e.target.value)}
                            style={{ 
                                width: '100%', 
                                padding: '0.75rem', 
                                marginTop: '0.25rem',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                fontSize: '0.875rem',
                                backgroundColor: 'white'
                            }}
                            disabled={uploading}
                        >
                            <option value="">-- Select Commodity --</option>
                            {tradedCommodities.map(commodity => (
                                <option key={commodity.id} value={commodity.commodity_name}>
                                    {commodity.commodity_name}
                                    {commodity.specifications && ` (${commodity.specifications})`}
                                </option>
                            ))}
                        </select>
                        {tradedCommodities.length === 0 && (
                            <div style={{ 
                                fontSize: '0.75rem', 
                                color: '#ef4444', 
                                marginTop: '0.5rem' 
                            }}>
                                No traded commodities found. Please add commodities first.
                            </div>
                        )}
                    </div>
                    <div>
                        <label style={{ 
                            display: 'block',
                            marginBottom: '0.5rem',
                            fontWeight: '500',
                            color: '#374151'
                        }}>
                            Select File: <span style={{ color: '#ef4444' }}>*</span>
                        </label>
                        <input
                            type="file"
                            onChange={handleFileSelect}
                            accept=".pdf,.docx,.xlsx,.pptx,.md,.html,.csv,.png,.jpg,.jpeg,.tiff,.bmp,.webp,.txt,.eml,.msg"
                            disabled={!selectedCommodity || uploading}
                            style={{
                                width: '100%',
                                padding: '0.5rem',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                fontSize: '0.875rem',
                                backgroundColor: !selectedCommodity || uploading ? '#f9fafb' : 'white'
                            }}
                        />
                        <div style={{ 
                            fontSize: '0.75rem', 
                            color: '#6b7280', 
                            marginTop: '0.5rem' 
                        }}>
                            Supports: PDF, DOCX, XLSX, PPTX, Markdown (.md), HTML, CSV, Images (PNG, JPG, JPEG, TIFF, BMP, WEBP), TXT, EML, MSG, AsciiDoc (Max 30MB)
                        </div>
                    </div>
                </div>
            }
            onConfirm={() => {}} // Handled by file input
            onCancel={() => {
                onClose();
                setSelectedCommodity(''); // Reset selection when cancelled
            }}
            confirmText="Upload"
            cancelText="Cancel"
            showConfirmButton={false} // Hide the confirm button since file input handles the action
        />
    );
};

export default CommodityUploadModal; 